import React__default, { useEffect } from 'react';
import { Alert, Modal, Loader } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { StoreDetailsRoot, Hooks } from '@grandvisionhq/stores-v2';

const StoreDetailModal = ({ storeCode , onModalClose  })=>{
    const { getFormattedLabel  } = useIntl();
    const { useStoreDetails  } = Hooks;
    const [storeDetailsQuery, storeDetailsQueryState] = useStoreDetails();
    const urls = React__default.useRef({});
    useEffect(()=>{
        storeDetailsQuery(parseInt(storeCode, 10));
    }, [
        storeCode,
        storeDetailsQuery
    ]);
    const loading = !storeDetailsQueryState.called || storeDetailsQueryState.loading;
    if (storeDetailsQueryState.error) {
        return /*#__PURE__*/ React__default.createElement(Alert, {
            message: getFormattedLabel('common.error.network')
        });
    }
    return /*#__PURE__*/ React__default.createElement(Modal, {
        isOpen: true,
        showIcon: true,
        className: "store-modal",
        onModalClose: onModalClose
    }, loading && /*#__PURE__*/ React__default.createElement(Loader, null), storeDetailsQueryState.data && /*#__PURE__*/ React__default.createElement(StoreDetailsRoot, {
        store: storeDetailsQueryState.data,
        hidePhone: false,
        hideEmail: false,
        urls: urls.current
    }));
};
var StoreDetailModal$1 = StoreDetailModal;

export { StoreDetailModal$1 as default };
//# sourceMappingURL=StoreDetailModal.js.map
